import { zip, AsyncZippable } from 'fflate'

import type { PreviewItem } from '../stores/printPreviewStore'

/**
 * Paczka ZIP z wygenerowanymi dokumentami. Dokumenty z folderem (jeden folder
 * na kierowce, gdy wydruk obejmowal wiecej niz jednego) trafiaja do katalogow,
 * reszta lezy plasko w archiwum.
 */
export const zipPreviewItems = async (
  items: PreviewItem[],
): Promise<Uint8Array> => {
  const entries = await Promise.all(
    items.map(async (item) => {
      const buffer = await fetch(item.blobUrl).then((r) => r.arrayBuffer())
      const path = item.folder ? `${item.folder}/${item.filename}` : item.filename
      return [path, new Uint8Array(buffer)] as const
    }),
  )

  const zippable: AsyncZippable = {}
  entries.forEach(([path, data], index) => {
    // Ten sam raport dla tego samego kierowcy nie powinien nadpisac poprzedniego.
    const unique =
      zippable[path] === undefined ? path : path.replace(/(\.[^.]+)?$/, `_${index}$1`)
    zippable[unique] = [data, { level: 0 }]
  })

  return new Promise((resolve, reject) => {
    zip(zippable, (err, result) => (err ? reject(err) : resolve(result)))
  })
}

const triggerDownload = (url: string, filename: string) => {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  triggerDownload(url, filename)
  // Zwolnienie adresu w tym samym ticku potrafi przerwac pobieranie.
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000)
}

/** Pobranie gotowego dokumentu; adres blob nalezy do wolajacego. */
export const downloadPreviewItem = (item: PreviewItem) =>
  triggerDownload(item.blobUrl, item.filename)
